import React, { useContext } from 'react';

import DevicesFilterChips from '@totem/components/devices/devicesContainer/DevicesFilterChips';
import DropdownFilter from '@totem/components/ui_components/filters/dropdownFilter/DropdownFilter';
import FiltersChipsContainer from '@totem/components/ui_components/filters/FilterChipsContainer';
import FiltersBody from '@totem/components/ui_components/filters/FiltersBody';
import FiltersContainer from '@totem/components/ui_components/filters/FiltersContainer';
import InputContext from '@totem/components/ui_components/reportSettings/InputContext';

import '../devices.css';

const styles = {
  dropdown: {
    marginRight: '2rem',
  },
};

type Props = {
  title?: string;
};

const DeviceFilters = (_props: Props) => {
  const { handleFilter, getFilterValues, getFilterOptions } =
    useContext(InputContext);

  const getDropdownOptions = (key: string) =>
    getFilterOptions(key).map((opt) => ({
      label: opt.text as string,
      value: opt.value,
    }));

  return (
    <FiltersContainer>
      <FiltersBody>
        <DropdownFilter
          label="Type"
          options={getDropdownOptions('type')}
          value={getFilterValues('type')}
          onChange={(update) => handleFilter('type', update)}
          style={styles.dropdown}
        />
        <DropdownFilter
          label="Vendor"
          options={getDropdownOptions('vendor')}
          value={getFilterValues('vendor')}
          onChange={(update) => handleFilter('vendor', update)}
          style={styles.dropdown}
        />
        <DropdownFilter
          label="Region"
          options={getDropdownOptions('region')}
          value={getFilterValues('region')}
          onChange={(update) => handleFilter('region', update)}
          style={styles.dropdown}
        />
        <DropdownFilter
          label="Building"
          options={getDropdownOptions('building')}
          value={getFilterValues('building')}
          onChange={(update) => handleFilter('building', update)}
          style={styles.dropdown}
        />
      </FiltersBody>
      <FiltersChipsContainer>
        <DevicesFilterChips />
      </FiltersChipsContainer>
    </FiltersContainer>
  );
};

export default DeviceFilters;
